module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/JFK.77b82cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/JFK.jpg
// module id = dsjL
// module chunks = 0